import {
  FETCH_LATEST_SKILL_GANGSTERS_REQUEST,
  FETCH_LATEST_SKILL_GANGSTERS_RECEIVED,
  FETCH_LATEST_SKILL_GANGSTERS_FAIL,
  FETCH_LATEST_GANGSTERS_REQUEST,
  FETCH_LATEST_GANGSTERS_RECEIVED,
  FETCH_LATEST_GANGSTERS_FAIL,
  FETCH_LATEST_DETECTIVE_REQUEST,
  FETCH_LATEST_DETECTIVE_RECEIVED,
  FETCH_LATEST_DETECTIVE_FAIL,
  FETCH_ANALYTICS_DATA_REQUEST,
  FETCH_ANALYTICS_DATA_RECEIVED,
  FETCH_ANALYTICS_DATA_FAIL,
  FETCH_POPULAR_GANGSTER_CLASS_PENDING,
  FETCH_POPULAR_GANGSTER_CLASS_FULFILLED,
  FETCH_POPULAR_GANGSTER_CLASS_FAIL,
  FETCH_POPULAR_DETECTIVE_CLASS_PENDING,
  FETCH_POPULAR_DETECTIVE_CLASS_FULFILLED,
  FETCH_POPULAR_DETECTIVE_CLASS_FAIL,
  FETCH_POPULAR_GANGSTER_LEVEL_PENDING,
  FETCH_POPULAR_GANGSTER_LEVEL_FULFILLED,
  FETCH_POPULAR_GANGSTER_LEVEL_FAIL,
  FETCH_POPULAR_DETECTIVE_LEVEL_PENDING,
  FETCH_POPULAR_DETECTIVE_LEVEL_FULFILLED,
  FETCH_POPULAR_DETECTIVE_LEVEL_FAIL,
} from "../actions/leaderboard.js";

const defaultState = {
  isSkillsLoading: false,
  isDetectivesLoading: false,
  isGangstersLoading: false,
  isAnalysticsLoading: false,

  skillsData: [],
  gangstersData: [],
  detectivesData: [],
  analysticsData: {},
  filteredGangsterClassData: [],
  isFilterPopularGangsterLoading: false,
  isFilterPopularGangsterError: null,
  filteredDetectiveClassData: [],
  isFilterPopularDetectiveLoading: false,
  isFilterPopularDetectiveError: null,
  filteredGangsterLevelData: [],
  filteredDetectiveLevelData: [],
  fetchSkillsError: "",
  fetchGangstersError: "",
  fetchDetectivesError: "",
  fetchAnaysticsError: "",
};

const reducer = (state = defaultState, action) => {
  switch (action.type) {
    case FETCH_LATEST_GANGSTERS_REQUEST:
      return {
        ...state,
        isGangstersLoading: true,
        fetchGangsterError: "",
      };

    case FETCH_LATEST_GANGSTERS_RECEIVED:
      return {
        ...state,
        gangstersData: action.data,
        isGangstersLoading: false,
        fetchGangsterError: "",
      };

    case FETCH_LATEST_GANGSTERS_FAIL:
      return {
        ...state,
        fetchGangsterError: action.error,
        isGangstersLoading: false,
      };

    case FETCH_LATEST_DETECTIVE_REQUEST:
      return {
        ...state,
        isDetectivesLoading: true,
        fetchDetectivesError: "",
      };

    case FETCH_LATEST_DETECTIVE_RECEIVED:
      return {
        ...state,
        isDetectivesLoading: false,
        detectivesData: action.data,
      };

    case FETCH_LATEST_DETECTIVE_FAIL:
      return {
        ...state,
        isDetectivesLoading: false,
        fetchDetectivesError: action.error,
      };

    case FETCH_LATEST_SKILL_GANGSTERS_REQUEST:
      return {
        ...state,
        isSkillsLoading: true,
        fetchSkillsError: "",
      };

    case FETCH_LATEST_SKILL_GANGSTERS_RECEIVED:
      return {
        ...state,
        isSkillsLoading: false,
        skillsData: action.data,
      };

    case FETCH_LATEST_SKILL_GANGSTERS_FAIL:
      return {
        ...state,
        isSkillsLoading: false,
        fetchSkillsError: action.error,
      };

    case FETCH_ANALYTICS_DATA_REQUEST:
      return {
        ...state,
        isAnalysticsLoading: true,
        fetchAnaysticsError: "",
      };

    case FETCH_ANALYTICS_DATA_RECEIVED:
      return {
        ...state,
        isAnalysticsLoading: false,
        analysticsData: action.data,
      };

    case FETCH_ANALYTICS_DATA_FAIL:
      return {
        ...state,
        isAnalysticsLoading: false,
        fetchAnaysticsError: action.error,
      };

    case FETCH_POPULAR_GANGSTER_CLASS_PENDING:
      return {
        ...state,
        isFilterPopularGangsterLoading: true,
      };

    case FETCH_POPULAR_GANGSTER_CLASS_FULFILLED:
      return {
        ...state,
        isFilterPopularGangsterLoading: false,
        filteredGangsterClassData: action.data.tokens,
      };

    case FETCH_POPULAR_GANGSTER_CLASS_FAIL:
      return {
        ...state,
        isFilterPopularGangsterLoading: false,
        isFilterPopularGangsterError: action.error,
      };

    case FETCH_POPULAR_DETECTIVE_CLASS_PENDING:
      return {
        ...state,
        isFilterPopularDetectiveLoading: true,
      };

    case FETCH_POPULAR_DETECTIVE_CLASS_FULFILLED:
      return {
        ...state,
        isFilterPopularDetectiveLoading: false,
        filteredDetectiveClassData: action.data.tokens,
      };

    case FETCH_POPULAR_DETECTIVE_CLASS_FAIL:
      return {
        ...state,
        isFilterPopularDetectiveLoading: false,
        isFilterPopularDetectiveError: action.error,
      };

    case FETCH_POPULAR_DETECTIVE_LEVEL_PENDING:
      return {
        ...state,
        isFilterPopularDetectiveLoading: true,
      };

    case FETCH_POPULAR_DETECTIVE_LEVEL_FULFILLED:
      return {
        ...state,
        isFilterPopularDetectiveLoading: false,
        filteredDetectiveLevelData: action.data.tokens,
      };

    case FETCH_POPULAR_DETECTIVE_LEVEL_FAIL:
      return {
        ...state,
        isFilterPopularDetectiveLoading: false,
        isFilterPopularDetectiveError: action.error,
      };

    case FETCH_POPULAR_GANGSTER_LEVEL_PENDING:
      return {
        ...state,
        isFilterPopularGangsterLoading: true,
      };

    case FETCH_POPULAR_GANGSTER_LEVEL_FULFILLED:
      return {
        ...state,
        isFilterPopularGangsterLoading: false,
        filteredGangsterLevelData: action.data.tokens,
      };

    case FETCH_POPULAR_GANGSTER_LEVEL_FAIL:
      return {
        ...state,
        isFilterPopularGangsterLoading: false,
        isFilterPopularGangsterError: action.error,
      };

    default:
      return state;
  }
};

export default reducer;
